import React from 'react'
import PropTypes from 'prop-types';
import { Row, Col } from "react-bootstrap"
import { Button, Collapse, SvgIcon } from '@mui/material';
import { NumericFormat } from 'react-number-format';
import ExpandMoreIcon from '../../../../../icons/expand-more.svg?react';

import '../../../Common/Cards/QuoteCard.scss';

export default function QuoteCard(props) {

  return (
    <div className="quote-card">
      <Row>
        <Col sm={4} className="d-flex align-items-start flex-column w-100">
          <div className="d-flex flex-column w-100">
            <img className="carrier-logo-lg" src={props.logoUrl} alt={`${props.carrierName} Logo`} />
          </div>
        </Col>
        <Col>
          <h4>{props.productName}</h4>
          {props.productNameSubtitle && <h5 className="primary-color">{props.productNameSubtitle}</h5>}
          <div className={`quote-underwriting-time ${props.underwritingTime ? '' : 'd-none'}`}>Typically <span>{props.underwritingTime}</span></div>
        </Col>
        <Col xs="auto">
          <p>
            <NumericFormat
              className="quote-amount-dollars"
              value={props.monthlyRate}
              displayType={'text'}
              thousandSeparator={true}
              decimalScale={2}
              fixedDecimalScale={true}
            />
            <span className="quote-amount-mo"> /mo</span>
          </p>
        </Col>
      </Row>
      <Row>
        <Col className="d-flex">
          <div className="quote-rating-section mt-auto">
            Rating &nbsp;<span className={`carrier-rating primary-color`}>{props.rating}</span>
          </div>
        </Col>
        <Col xs={12} sm={3} className="d-flex justify-content-center">
          <Button
            className="w-100 apply"
            color="primary"
            variant="contained"
            onClick={props.onClick}
          >
            {props.buttonText || "Select"}
          </Button>
        </Col>
      </Row>
      <Row className={`quote-details-section ${props.expanded ? 'expanded' : ''}`}>
        <Collapse in={props.expanded} className="w-100 px-0">
          <Col className="py-3">
            {props.productDetails}
          </Col>
        </Collapse>
        <Col sm={{ span: "auto", offset: 4 }} className="d-flex justify-content-center product-details-btn">
          <Button variant="text" color='inherit' className="expand" onClick={props.expand}>
            PRODUCT DETAILS
            <SvgIcon component={ExpandMoreIcon} className={props.expanded ? 'expanded' : ''} />
          </Button>
        </Col>
      </Row>
    </div>
  )
}

QuoteCard.propTypes = {
  carrierName: PropTypes.string.isRequired,
  monthlyRate: PropTypes.number.isRequired,
  onClick: PropTypes.func.isRequired,
  expanded: PropTypes.bool.isRequired,
  expand: PropTypes.func.isRequired,
  productDetails: PropTypes.object.isRequired,
  buttonText: PropTypes.string,
}
